import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Connexion from '../views/Connexion.vue'
import Clients from '../views/Clients.vue'
import Client from '../views/Client.vue'
import Creation from '../views/CreationFiche.vue'
import Agences from '../views/Agences.vue'
import Agence from '../views/Agence.vue'
import Rencontre from '../views/Rencontre.vue'
import Message from '../views/Message.vue'
import Matching from '../views/Matching.vue'
import Leads from '../views/Leads.vue'
import Reglages from '../views/Reglages.vue'
import Facture from '../views/Facture.vue'
import PageNotFound from '../views/404.vue'
import Tutorial from '../views/Tutorial.vue'
import Password from '../views/Password.vue'
import Utilisateurs from '../views/Utilisateurs.vue'

import { useUserStore } from '../stores/user'
import CreationAgence from '../views/CreationAgence.vue'
import Documents from '../views/Documents.vue'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			name: 'Dashboard',
			component: Dashboard,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/connexion',
			name: 'Connexion',
			component: Connexion,
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/mot-de-passe',
			name: 'password',
			component: Password,
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/tutoriels',
			name: 'Tutoriels',
			component: Tutorial,
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/clients',
			name: 'Clients',
			component: Clients,
			children: [
				{ path: 'fiche/:id', name: 'Client', component: Client},
				{ path: 'fiche/creation', name: 'Creation', component: Creation}
			],
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/documents',
			name: 'Documents',
			component: Documents,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/factures',
			name: 'Factures',
			component: Facture,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/matchings',
			name: 'Matchings',
			component: Matching,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/rencontres',
			name: 'Rencontres',
			component: Rencontre,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/messages',
			name: 'Messages',
			component: Message,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/utilisateurs',
			name: 'Utilisateurs',
			component: Utilisateurs,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/agences',
			children: [
				{ 
					path: "", name: "Agences", component: Agences, children: 
					[
						{ path: 'agence/:id', name: 'Agence', component: Agence},
						{ path: 'agence/creation', name: 'Creation Agence', component: CreationAgence}
					]
				},
			],
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/leads/',
			name: 'Leads',
			component: Leads,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/reglages/',
			name: 'Reglages',
			component: Reglages,
			meta: {
				requiresAuth: true
			}
		},
		{ 
			path: '/:pathMatch(.*)*', 
			name: 'NotFound',
			component: PageNotFound 
		},
	],
})

router.beforeEach(async (to, from, next) => {
	const store = useUserStore();
	const isAuthenticated = store.userLog?.token;
	let invalidToken = false;

	if (isAuthenticated) {
		try {
			const res = await store.checkToken(store.userLog.id_util, store.userLog.token);
			invalidToken = false;
		} catch (err) {
			invalidToken = true;
		}
	}

	if (to.meta.requiresAuth && (!isAuthenticated || invalidToken)) {
		next({ name: 'Connexion' });
	} else if (to.name === 'Connexion' && isAuthenticated && !invalidToken) {
		next({ name: 'Dashboard' });
	} else {
		next();
	}
})

export default router
